import * as z from "zod";
import type { ApiContext } from "../context";
import { type ApiNotAuthorized, UnexpectedApiError, ValidationError } from "../errors";
import { parse } from "../model/common";
import { ApproximateLocation, GeoCountry } from "../model/shop";
import { forward, type Result } from "../result";
import type { Transport } from "../transport";

const CountriesResponse = z.object({ countries: z.array(GeoCountry) });

/** `/geo`: the address form's vocabulary, and a rough fix on where the caller is. */
export class GeoApi {
  constructor(private readonly t: Transport) {}

  async countries(ctx: ApiContext): Promise<Result<GeoCountry[], ApiNotAuthorized>> {
    const r = await this.t.get(ctx, "/geo/countries");
    return forward(
      r,
      (j) => parse(CountriesResponse, j).countries,
      (e) => {
        if (e instanceof ValidationError) throw new UnexpectedApiError(e);
        return e;
      },
    );
  }

  /** Where the caller probably is, from their IP. Never fails: `available` says whether anything was resolved. */
  async approximate(ctx: ApiContext): Promise<Result<ApproximateLocation, ApiNotAuthorized>> {
    const r = await this.t.get(ctx, "/geo/approximate");
    return forward(
      r,
      (j) => parse(ApproximateLocation, j),
      (e) => {
        if (e instanceof ValidationError) throw new UnexpectedApiError(e);
        return e;
      },
    );
  }
}
